module.exports = __webpack_public_path__ + "img/small-studio-logo.92949d4.png";